export default class RevenueUpdate {

  static STATUS_ICONS = {
    ready: 'ion-ios-arrow-forward',
    completed: 'ion-md-checkmark',
    failed: 'ion-md-close',
    active: 'ion-ios-arrow-forward',
  };

  static STATUS_COLORS = {
    ready: 'text-info',
    completed: 'text-success',
    failed: 'text-danger',
    active: 'text-primary',
    unhandled: 'text-muted',
  };

  state;
  status;

  constructor(data = {}) {
    Object.assign(this, data);
  }

  getIcon() {
    if (!RevenueUpdate.STATUS_ICONS.hasOwnProperty(this.status)) {
      return '';
    }

    return RevenueUpdate.STATUS_ICONS[this.status];
  }

  getColor() {
    if (!RevenueUpdate.STATUS_COLORS.hasOwnProperty(this.status)) {
      return '';
    }

    return RevenueUpdate.STATUS_COLORS[this.status];
  }
}